import { Subscription } from './Subscription';

/**
 * Observateur minimaliste.
 *
 * Sert à brancher loader global, notifications et journalisation sur le cycle de
 * vie des appels HTTP sans que les vues aient à connaître la couche réseau.
 * Un abonné qui lève une exception n'interrompt pas les suivants.
 */
export class SimpleObserver<T = any> {
	private handlers: ((payload: T) => void)[] = [];

	subscribe(handler: (payload: T) => void): Subscription {
		this.handlers.push(handler);
		return new Subscription(() => {
			const index = this.handlers.indexOf(handler);
			if (index !== -1) {
				this.handlers.splice(index, 1);
			}
		});
	}

	trigger(payload: T): void {
		for (const handler of [...this.handlers]) {
			try {
				handler(payload);
			} catch (error) {
				console.error('Observateur en erreur :', error);
			}
		}
	}

	clear(): void {
		this.handlers = [];
	}
}
